import {TListItem} from './types';
import loopMap from 'mn-utils/loopMap';
import faker from '@faker-js/faker';

export const getRefundList = (limit: number): TListItem[] => {
  return loopMap(limit, () => {
    return getRefundItem();
  }) as TListItem[];
};

export const getRefundItem = (): TListItem => {
  const kinds = ['full', 'part'];
  const statuses = ['requested', 'completed', 'pending', 'cancelled'];
  const networks = ['bitcoin', 'bsc', 'ethereum', 'ripple', 'tron', 'polkadot'];
  return {
    id: faker.datatype.uuid(),
    kind: (faker.helpers as any).arrayElement(kinds),
    email: faker.internet.email(),
    order_id: faker.datatype.uuid(),
    auction_id: faker.datatype.uuid(),
    payment_id: faker.datatype.uuid(),
    fiat_amount: faker.finance.amount(0, 1000, 2),
    fiat_code: faker.finance.currencyCode(),
    ...(faker.datatype.boolean() ? {currency_amount: faker.finance.amount(0, 10, 2)} : {}),
    asset_code: faker.finance.currencyCode(),
    created_at: faker.date.recent().toISOString(),
    status: (faker.helpers as any).arrayElement(statuses),
    ...(faker.datatype.boolean() ? {hash: faker.finance.ethereumAddress()} : {}),
    ...(faker.datatype.boolean() ? {network: (faker.helpers as any).arrayElement(networks)} : {}),
  } as TListItem;
};
